<div class="custom-snackbar">
  <mat-icon class="snackbar-icon" [ngClass]="{'success': data.type === 'success', 'error': data.type === 'error'}">{{ icon }}</mat-icon>
  <div class="snackbar-message">
    @if (isString(message)) {
      <span>{{ message }}</span>
    } @else {
      @for (msg of message; track msg) {
        <span>
          {{ msg?.description }} <br>
        </span>
      }
    }
  </div>
  <button class="snackbar-close" (click)="dismiss()">
    <mat-icon>close</mat-icon>
  </button>
</div>
